import "../Tweets.css";

//react
import { useEffect, useState } from "react";

//components
import TweetGraph from "../../reusable/TweetGraph/TweetGraph";

//antd
import { Divider, Typography } from "antd";

//hooks
import { useCurrentLanguage } from "../../../hooks/useCurrentLanguage";

//utils
import { getCsvData } from "../../../utils/functions/getCsvData";

//assets
import TEXT from "../../../utils/text/prensa.json";

//functionss
import { formatTrimesterLabel } from "../../../utils/functions/formatTrimesterLabel";

const { Title } = Typography;

export default function Discussion({
  selectedCountry,
  countryName,
  countryOptions,
  setImg1,
  setImg2,
  setImg3,
  setImg4,
  setImg5,
  setImg6,
  //setImg7
}) {
  //language
  const { language } = useCurrentLanguage();

  //useState - topics_top3
  const [dataTopicsTop3, setDataTopicsTop3] = useState([]);

  //useState - data All Sankey
  const [dataAllSankey, setDataAllSankey] = useState([]);

  //useState - data Country Sankey
  const [dataCountrySankey, setDataCountrySankey] = useState([]);

  //useState - data res
  const [data_res, setData_res] = useState([]);

  //useState - data res shares
  const [data_res_shares, setData_res_shares] = useState([]);

  //useState - img url 1
  const [imgUrl1, setImgUrl1] = useState("");
  const [imgUrl5, setImgUrl5] = useState("");

  //isLac
  const isLac = selectedCountry === "LAC";

  //useEffect
  useEffect(() => {
    processDataTop3();
    processDataAllSankey("2023", 4);
    processData_res();
    processData_res_shares();
    processDataCountrySankey("2020");
    console.log("selectedCountry", selectedCountry);
    console.log(dataAllSankey);
    console.log(dataCountrySankey);
    console.log(data_res_shares);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedCountry]);

  //useEffect - imgs
  useEffect(() => {
    setImg1(imgUrl1);
    setImg5(imgUrl5);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [imgUrl1, imgUrl5]);

  const processDataAllSankey = async (selectedYear, selectedTrimester) => {
    let temp = await processSankey(
      selectedYear,
      selectedTrimester,
      `/data/discussion/sankey_completo_trim.csv`,
      undefined
    );
    setDataAllSankey(temp);
  };

  const processDataCountrySankey = async (selectedYear) => {
    if (selectedCountry === "LAC") return;
    let temp = await processCountrySankey(
      selectedYear,
      selectedCountry,
      `/data/discussion/source_timeseries.csv`
    );
    setDataCountrySankey(temp);
  };

  const processCountrySankey = async (
    selectedYear,
    selectedCountry,
    csvFile
  ) => {
    let df = await getCsvData(csvFile);

    // Extract years from the 'date' column and create a list of available years
    let years = [];
    df.forEach((e) => {
      let year = new Date(e.date).getFullYear();
      if (!years.includes(year)) years.push(year);
    });

    let yearOptions = years.map((year) => ({ code: year, label: year }));

    // Filter data for the selected year and country
    df = df.filter((row) => row.country === selectedCountry);

    let sourceIndex = "country"; // The source is the selected country
    let valueColumns = [
      "United States",
      "El Salvador",
      "Brazil",
      "Mexico",
      "Venezuela",
      "Panama",
      "Colombia",
      "Caribe",
      "Bolivia",
      "Chile",
      "Nicaragua",
      "Honduras",
      "Ecuador",
      "Argentina",
      "Peru",
      "Costa Rica",
      "Guatemala",
      "Belize",
      "Paraguay",
      "Uruguay",
    ];

    let nodes = [];
    let links = [];
    let linkMap = {};

    // Construct nodes and links for the selected country
    df.forEach((row) => {
      valueColumns
        .filter((country) => country !== selectedCountry)
        .forEach((target) => {
          if (row[target] > 0) {
            if (!nodes.some((item) => item.name === row[sourceIndex])) {
              nodes.push({ name: row[sourceIndex] });
            }
            if (!nodes.some((item) => item.name === target)) {
              nodes.push({ name: target });
            }

            let key = `${row[sourceIndex]}->${target}`;

            if (linkMap[key]) {
              linkMap[key].value += parseFloat(row[target]);
            } else {
              linkMap[key] = {
                source: row[sourceIndex], // The selected country in the row
                target: target, // The target column name
                value: parseFloat(row[target]),
              };
            }
          }
        });
    });

    const totalLinkMap = Object.values(linkMap).reduce((acc, link) => {
      acc += link.value;
      return acc;
    }, 0);

    // Convert the linkMap to an array of links
    links = Object.values(linkMap)
      .sort((a, b) => b.value - a.value)
      .slice(0, 10)
      .map((link) => {
        return {
          source: link.source,
          target: link.target,
          value: ((link.value / totalLinkMap) * 100).toFixed(2),
        };
      });

    nodes = nodes.filter((node) =>
      links.some(
        (link) => link.source === node.name || link.target === node.name
      )
    );

    let temp = [
      {
        id: "q1",
        data: nodes,
        links: links,
        years: yearOptions,
        selectedYear: selectedYear,
        rotate: false,
        graphType: "sankey",
        hasOptions: false,
        isPercentage: false,
      },
    ];

    return temp;
  };

  const processSankey = async (
    selectedYear,
    selectedTrimester,
    csvFile,
    year
  ) => {
    let df = await getCsvData(csvFile);

    //setup period filters
    let years = [];
    df.forEach((e) => {
      if (!years.includes(e.year)) years.push(e.year);
    });
    let yearOptions = [];
    years.forEach((e) => {
      yearOptions.push({ code: e, label: e });
    });

    //let selectedYear = years[0]
    let trimesters = [];
    df.forEach((e) => {
      if (!trimesters.includes(e.trimester) && e.year === selectedYear)
        trimesters.push(e.trimester);
    });

    let trimesterOptions = [];
    trimesters.forEach((e) => {
      if (language === "es")
        trimesterOptions.push({ code: `T${e}`, label: `T${e}` });
      else trimesterOptions.push({ code: `Q${e}`, label: `Q${e}` });
    });

    if (selectedTrimester === -1)
      selectedTrimester = parseInt(trimesters[trimesters.length - 1]);

    //filter df by year and trimester
    df = df.filter(
      (row) =>
        row.year === selectedYear &&
        row.trimester === selectedTrimester.toString()
    );

    let sourceIndex = "source";
    let targetIndex = "target";
    let valueIndex = "value";
    let percentageIndex = "percentage";

    let nodes = [];
    let links = [];

    df.forEach((e) => {
      if (!nodes.some((item) => item.name === e[sourceIndex])) {
        nodes.push({ name: e[sourceIndex] });
      }

      if (!nodes.some((item) => item.name === e[targetIndex])) {
        nodes.push({ name: e[targetIndex] });
      }
    });

    df.forEach((e) => {
      let tempLink = {
        source: e[sourceIndex],
        target: e[targetIndex],
        value: parseFloat(e[valueIndex]).toFixed(2),
      };
      if (e[percentageIndex]) {
        tempLink.percentage = parseFloat(e[percentageIndex]).toFixed(2);
      }
      links.push(tempLink);
    });

    const slicedLinks = links.slice(0, 10);

    let temp = [
      {
        id: "q1",
        data: nodes,
        links: slicedLinks,
        years: yearOptions,
        trimesters: trimesterOptions,
        selectedYear: selectedYear,
        selectedTrimester: `T${selectedTrimester}`,
        rotate: false,
        graphType: "sankey",
        hasOptions: true,
        isPercentage: true,
        description:
          "Para analizar el encuadre temático de las noticias sobre migración, se desarrollaron modelos personalizados para identificar los temas de interés. Para ello se utilizan representaciones numéricas o vectoriales de textos, conocidas como embeddings, para representar dichos temas. Específicamente, se empleó el modelo 'paraphrase-multilingual-MiniLM-L12-v2'. El proceso comienza con la definición de palabras clave y ejemplos representativos de las categorías de interés, los cuales se vectorizan y se utilizan como base para las comparaciones mediante el método de similitud coseno. Cada noticia que se desea catalogar se convierte en un vector utilizando los embeddings del mismo modelo. Posteriormente, estos vectores se comparan con los conjuntos de vectores generados para cada tema, formando una base de datos. La pertenencia de cada noticia migratoria a alguna categoría se determina comparando su vector con las bases de vectores mediante la similitud coseno, que produce un valor entre 0 y 1. Para clasificar una noticia en un tema específico, se selecciona el tema con la similitud máxima siempre que esta sea superior a un umbral de 0.6. En el modelo se toman en cuenta las tres temáticas con mayor porcentaje de similitud. Si ninguna similitud supera este umbral, la noticia se clasifica como no perteneciente a ninguno de los temas definidos. ",
      },
    ];

    return temp;
  };

  const processDataTop3 = async () => {
    let df1 = await getCsvData(`/data/discussion/topics_top3_3m.csv`);

    //sort by date
    df1.sort((a, b) => new Date(a.date) - new Date(b.date));

    //filter country
    if (selectedCountry !== "LAC") {
      df1 = df1.filter((row) => row.country === selectedCountry);
    } else {
      let tempDf1 = {};
      df1.forEach((e) => {
        const date = formatTrimesterLabel(e.date, language);
        if (!tempDf1[date]) {
          tempDf1[date] = {
            date: e.date,
            seguridad: 0,
            servicios: 0,
            empleo: 0,
            politicas: 0,
            transito: 0,
            count: 0,
          };
        }
        tempDf1[date].seguridad += parseFloat(e.seguridad) || 0;
        tempDf1[date].servicios += parseFloat(e.servicios) || 0;
        tempDf1[date].empleo += parseFloat(e.empleo) || 0;
        tempDf1[date].politicas += parseFloat(e.politicas) || 0;
        tempDf1[date].transito += parseFloat(e.transito) || 0;
        tempDf1[date].count++;
      });

      df1 = Object.values(tempDf1).map((entry) => ({
        date: entry.date,
        seguridad: entry.seguridad / entry.count,
        servicios: entry.servicios / entry.count,
        empleo: entry.empleo / entry.count,
        politicas: entry.politicas / entry.count,
        transito: entry.transito / entry.count,
      }));
    }

    console.log("DF1", df1);

    let dates = [];
    let values = [];
    let values2 = [];
    let values3 = [];
    let values4 = [];
    let values5 = [];

    df1.forEach((e) => {
      dates.push(formatTrimesterLabel(e.date, language));
      values.push(parseFloat(e.seguridad));
      values2.push(parseFloat(e.servicios));
      values3.push(parseFloat(e.empleo));
      values4.push(parseFloat(e.politicas));
      values5.push(parseFloat(e.transito));
    });

    let combinedArray = [dates, values, values2, values3, values4, values5];

    let temp = [
      {
        id: "q1",
        data: combinedArray,
        rotate: false,
        graphType: "line",
        hasOptions: false,
        isPercentage: true,
        seriesName:
          language === "es"
            ? ["Seguridad", "Servicios", "Empleo", "Políticas", "Tránsito"]
            : ["Security", "Services", "Employment", "Policies", "Transit"],
        updateTotrimester: false,
        useColors: false,
        description: TEXT["indicadores"]["discussion1"][language],
      },
    ];

    setDataTopicsTop3(temp);
  };

  const processData_res = async () => {
    let df1 = await getCsvData(`/data/discussion/responzability_3m.csv`);

    //filter country
    if (selectedCountry !== "LAC") {
      df1 = df1.filter((row) => row.country === selectedCountry);
    } else {
      let tempDf1 = {};
      df1.forEach((e) => {
        const date = formatTrimesterLabel(e.date, language);
        if (!tempDf1[date]) {
          tempDf1[date] = {
            date: e.date,
            victima: 0,
            responzable: 0,
            count: 0,
          };
        }
        tempDf1[date].victima += parseFloat(e.victima) || 0;
        tempDf1[date].responzable += parseFloat(e.responzable) || 0;
        tempDf1[date].count++;
      });

      df1 = Object.values(tempDf1).map((entry) => ({
        date: entry.date,
        victima: entry.victima / entry.count,
        responzable: entry.responzable / entry.count,
      }));
    }

    let dates = [];
    let values = [];
    let values2 = [];

    df1.forEach((e) => {
      dates.push(formatTrimesterLabel(e.date, language));
      values.push(parseFloat(e.victima));
      values2.push(parseFloat(e.responzable));
    });

    let combinedArray = [dates, values, values2];

    /*let combinedArray2 = [
      language === "es"
        ? ["Victimas", "Responsables"]
        : ["Victims", "Responsible"],
      dates,
      [values, values2],
    ];*/

    //console.log("combinedArray2", combinedArray2);

    console.log()
    let temp2 = [
      {
        id: "q1",
        data: combinedArray,
        rotate: false,
        graphType: "line",
        hasOptions: false,
        isPercentage: true,
        seriesName:
          language === "es"
            ? ["Víctimas", "Responsables"]
            : ["Victims", "Responsible"],
        updateTotrimester: false,
        description: TEXT["indicadores"]["discussion2"][language],
      },
    ];

    console.log("RESPONSABILITY DATA 2", temp2);

    setData_res(temp2);
  };

  const processData_res_shares = async () => {
    let df1 = await getCsvData(`/data/discussion/responzability_shares_3m.csv`);

    //filter country
    if (selectedCountry !== "LAC") {
      df1 = df1.filter((row) => row.country === selectedCountry);
    } else {
      let tempDf1 = {};
      df1.forEach((e) => {
        const date = formatTrimesterLabel(e.date);
        if (!tempDf1[date]) {
          tempDf1[date] = {
            date: e.date,
            victima_shares: 0,
            responzable_shares: 0,
            count: 0,
          };
        }
        tempDf1[date].victima_shares += parseFloat(e.victima_shares) || 0;
        tempDf1[date].responzable_shares +=
          parseFloat(e.responzable_shares) || 0;
        tempDf1[date].count++;
      });

      df1 = Object.values(tempDf1).map((entry) => ({
        date: entry.date,
        victima_shares: entry.victima_shares / entry.count,
        responzable_shares: entry.responzable_shares / entry.count,
      }));
    }

    let dates = [];
    let values = [];
    let values2 = [];

    df1.forEach((e) => {
      dates.push(formatTrimesterLabel(e.date, language));
      values.push(parseFloat(e.victima_shares));
      values2.push(parseFloat(e.responzable_shares));
    });

    let combinedArray2 = [dates, values, values2];
    //console.log("combinedArray2", combinedArray2);

    let temp2 = [
      {
        id: "q1",
        data: combinedArray2,
        rotate: false,
        graphType: "line",
        hasOptions: false,
        isPercentage: true,
        seriesName:
          language === "es"
            ? ["Víctimas", "Responsables"]
            : ["Victims", "Responsible"],
        updateTotrimester: false,
      },
    ];

    setData_res_shares(temp2);
  };

  // const handleYearChange = (value, key) => {
  //     //get index of selected year (using the last trimester of the year)
  //     if(key === 'all')  {
  //         processDataAllSankey(value, -1)
  //     }

  // }

  // const handleAllTrimesterChange = (year, value, key) => {
  //     //processDataAllSankey(year, parseInt(value.split("T")[1]))
  //     if(key === 'all') {
  //         processDataAllSankey(year, parseInt(value.split("T")[1]))
  //     }
  // }

  return (
    <div
      className={`surveys-page-content ${
        !isLac ? "prensa-small-section-container" : ""
      }`}
    >
      <div className="surveys-page-graphs">
        <div className="survey-page-full-surveys">
          <div
            className={`full-screen ${
              isLac ? "prensa-chart-container sm:!gap-20" : ""
            }`}
          >
            <div>
              {dataTopicsTop3.length > 0 && (
                <TweetGraph
                  data={dataTopicsTop3}
                  title={
                    TEXT["topics"]["topics"]["title"][language] + countryName
                  }
                  setImgUrl={setImgUrl1}
                />
              )}
            </div>
            <div className="prensa-chart-info-container pt-8">
              {isLac && (
                <>
                  <div
                    className={`data-page-section-title prensa-chart-title text-left w-full ${
                      isLac ? "" : "mb-6"
                    }`}
                  >
                    {TEXT["topics"][language]}
                  </div>
                  <Title
                    level={2}
                    style={{ color: "var(--blue-primary)", textAlign: "left" }}
                  >
                    {TEXT["topics"]["title"][language]}
                  </Title>
                  <div className="prensa-text-container">
                    <p>{TEXT["topics"]["description"][language]}</p>
                  </div>
                </>
              )}
            </div>
            {/* all sankey */}
            {/* {dataAllSankey.length > 0 && <TweetGraph data={dataAllSankey} title={TEXT['topics']['sankey_all']['title'][language]} setImgUrl={setImgUrl5} onYearChange={(val) => handleYearChange(val, 'all')} onTrimesterChange={(year, val) => handleAllTrimesterChange(year, val, 'all')}/>} */}

            {/* topics top 3 */}
            {/* {dataTopicsTop3.length > 0 && <TweetGraph data={dataTopicsTop3} title={TEXT['topics']['topics_top3']['title'][language] + " " + countryName} setImgUrl={setImgUrl1}/>} */}

            {/* responsabilizacion a sentimiento */}
            {/* {data_res.length > 0 && <TweetGraph data={data_res} title={TEXT['sentiment']['responsabilization']['title'][language] + " " + countryName + TEXT['sentiment']['responsabilization']['title2'][language]} setImgUrl={setImgUrl5}/>} */}

            {/* responsabilizacion a sentimiento */}
            {/* {data_res_shares.length > 0 && <TweetGraph data={data_res_shares} title={TEXT['sentiment']['responsabilization_shares']['title'][language] + " " + countryName} setImgUrl={setImgUrl5}/>} */}

            {/* country sankey */}
            {/* {dataCountrySankey.length > 0 && <TweetGraph data={dataCountrySankey} title={TEXT['topics']['sankey_country']['title'][language] + " " + countryName} setImgUrl={setImgUrl5} />} */}
          </div>
          <Divider className="divider-full-screen" />
          <div
            className={`full-screen ${
              isLac ? "prensa-chart-container sm:!gap-20" : ""
            }`}
          >
            <div className="prensa-chart-info-container">
              <div
                className={`data-page-section-title prensa-chart-title text-left ${
                  isLac ? "" : "mb-6"
                }`}
              >
                {TEXT["topics"]["responsability"]["title_sec"][language]}
              </div>
              {isLac && (
                <>
                  <Title
                    level={2}
                    style={{ color: "var(--blue-primary)", textAlign: "left" }}
                  >
                    {TEXT["topics"]["responsability"]["title"][language]}
                  </Title>
                  <div className="prensa-text-container">
                    <p>
                      {
                        TEXT["topics"]["responsability"]["description"][
                          language
                        ]
                      }
                    </p>
                  </div>
                </>
              )}
            </div>
            <div>
              {data_res.length > 0 && (
                <TweetGraph
                  data={data_res}
                  title={
                    TEXT["topics"]["responsability"]["title_graph"][language] +
                    countryName
                  }
                  setImgUrl={setImgUrl5}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
